/**
 * 业绩统计组件
 * 重构版 - 使用拆分的模块
 */

import React from 'react';
import { Card, Table, Select, Spin, Empty, Button, Space } from 'antd';
import { ReloadOutlined, EditOutlined } from '@ant-design/icons';

import { usePerformanceStatistics, getPerformanceColumns } from './PerformanceStatisticsModule';
import DepartmentDetailModal from './DepartmentDetailModal';
import PerformanceEntryModal from './PerformanceEntryModal';

const PerformanceStatisticsComponent: React.FC = () => {
    const {
        loading,
        periods,
        selectedPeriodId,
        statistics,
        detailModalVisible,
        detailLoading,
        selectedDeptDetail,
        entryModalVisible,
        setSelectedPeriodId,
        loadStatistics,
        viewDepartmentDetail,
        setDetailModalVisible,
        setEntryModalVisible,
    } = usePerformanceStatistics();

    const columns = getPerformanceColumns({ viewDepartmentDetail });

    return (
        <div className="performance-statistics" style={{ padding: 24 }}>
            {/* 顶部操作区 */}
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
                <div>
                    <span style={{ marginRight: 8 }}>考核周期：</span>
                    <Select
                        style={{ width: 240 }}
                        placeholder="选择考核周期"
                        value={selectedPeriodId}
                        onChange={setSelectedPeriodId}
                        loading={periods.length === 0}
                    >
                        {periods.map((period) => (
                            <Select.Option key={period.id} value={period.id}>
                                {period.name} ({period.period_type_display})
                            </Select.Option>
                        ))}
                    </Select>
                </div>
                <Space>
                    <Button icon={<EditOutlined />} onClick={() => setEntryModalVisible(true)}>
                        录入数据
                    </Button>
                    <Button icon={<ReloadOutlined />} onClick={loadStatistics} loading={loading}>
                        刷新
                    </Button>
                </Space>
            </div>

            <Spin spinning={loading}>
                {statistics ? (
                    <>
                        {/* 统计卡片 */}
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 16 }}>
                            {[
                                { label: '参与部门', value: statistics.department_count },
                                { label: '平均得分', value: statistics.avg_score.toFixed(1) },
                                { label: '最高得分', value: statistics.max_score.toFixed(1) },
                                { label: '最低得分', value: statistics.min_score.toFixed(1) },
                            ].map((item, idx) => (
                                <Card key={idx} size="small">
                                    <div style={{ fontSize: 24, fontWeight: 'bold' }}>{item.value}</div>
                                    <div style={{ color: '#888' }}>{item.label}</div>
                                </Card>
                            ))}
                        </div>

                        {/* 排名表格 */}
                        <Card title="部门业绩排名" size="small" bordered={false}>
                            <Table
                                columns={columns}
                                dataSource={statistics.department_performances}
                                rowKey="id"
                                pagination={false}
                                size="middle"
                            />
                        </Card>
                    </>
                ) : (
                    <Empty description="暂无业绩数据" />
                )}
            </Spin>

            {/* 子组件弹窗 */}
            <DepartmentDetailModal
                visible={detailModalVisible}
                loading={detailLoading}
                detail={selectedDeptDetail}
                onCancel={() => setDetailModalVisible(false)}
            />

            <PerformanceEntryModal
                visible={entryModalVisible}
                onCancel={() => setEntryModalVisible(false)}
                onSuccess={() => {
                    setEntryModalVisible(false);
                    loadStatistics();
                }}
            />
        </div>
    );
};

export default PerformanceStatisticsComponent;
